import { message, Modal } from 'antd';
import React from 'react';

import { ExclamationCircleOutlined } from '@ant-design/icons';

import type { GroupBuyingOrdersService, TableValuesFromOrder } from '../types';

export const cancelGroupOrder = async (args: {
  groupBuyingOrdersService: GroupBuyingOrdersService;
  order: TableValuesFromOrder;
  updateOrders: () => void;
}) => {
  const { groupBuyingOrdersService, order, updateOrders } = args;

  try {
    await groupBuyingOrdersService.patch(order._id, {
      paymentStatus: '已取消',
    });
    updateOrders();
    message.success('訂單取消成功!');
  } catch (error) {
    message.error('訂單取消失敗!');
    console.error(error);
  }
};

export const confirmCancel = (args: {
  groupBuyingOrdersService: GroupBuyingOrdersService;
  order: TableValuesFromOrder;
  updateOrders: () => void;
}) => {
  const { groupBuyingOrdersService, order, updateOrders } = args;

  Modal.confirm({
    title: '確定取消該團購嗎？',
    icon: <ExclamationCircleOutlined />,
    content: '取消後將無法復原!!',
    okText: '確定',
    cancelText: '取消',
    onOk: () =>
      cancelGroupOrder({ groupBuyingOrdersService, order, updateOrders }),
    onCancel: (close) => close(),
  });
};
